export default function getQuerySize (query) {
    if (typeof query !== 'object' || query === null) return 0
    let size = Object.keys(query).length
    if (query.sortuj) size -= 1
    if (query.zasieg) size -= 1
    if (query.strona) size -= 1
    return size
}